import React, { useState, useEffect } from "react";
import MyTypeWriter from "../components/units/MyTypeWriter";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import SEO from "../components/seo/SEO";
import { seoConfig } from "../config/seoConfig";

const Todoist_component = () => {
  const [toDoListData, setToDoListData] = useState([]);
  const [inputData, setInputData] = useState("");

  // 提取日期格式化函数
  const getFormattedDate = (date) => {
    return new Date(date).toLocaleString("zh-CN", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // 从 localStorage 加载数据
  useEffect(() => {
    const savedToDoList = localStorage.getItem("todoList");
    if (savedToDoList) {
      setToDoListData(JSON.parse(savedToDoList));
    }
  }, []);

  // 保存到 localStorage
  const saveToLocalStorage = (newList) => {
    localStorage.setItem("todoList", JSON.stringify(newList));
  };

  // 删除待办事项
  const handleDeleteList = (index) => {
    const updatedList = toDoListData.filter((_, i) => i !== index);
    setToDoListData(updatedList);
    saveToLocalStorage(updatedList);
  };

  // 输入框内容更新
  const handleInputData = (e) => {
    setInputData(e.target.value);
  };

  // 添加新的待办事项
  const handleAddList = () => {
    if (toDoListData.length > 8) {
      alert("数据过多，影响浏览器性能，请删除一些事项");
      return;
    }
    const newTodo = {
      id: `todo-${Date.now()}`, // 添加唯一 id
      text: inputData,
      date: new Date(),
    };
    const updatedList = [...toDoListData, newTodo];
    setToDoListData(updatedList);
    saveToLocalStorage(updatedList);
    setInputData("");
  };

  // 处理拖拽结束事件
  const onDragEnd = (result) => {
    // 如果拖拽到列表外，不做处理
    if (!result.destination) {
      return;
    }

    // 重新排序数组
    const items = Array.from(toDoListData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setToDoListData(items);
    saveToLocalStorage(items);
  };

  return (
    <>
      <SEO {...seoConfig.home} path="/write" />
      <div style={{ height: "90vh" }}>
        <div>
          <MyTypeWriter h={"待办事项清单"} />

          <div className="container text-left">
            <div className="row">
              <div className="col-2"></div>
              <div className="col-8">
                <div className="input-group mb-3">
                  <input
                    value={inputData}
                    onChange={handleInputData}
                    type="text"
                    className="form-control"
                    placeholder="请输入待添加的提醒事项..."
                  />
                  <button
                    onClick={handleAddList}
                    className="btn btn-outline-secondary"
                    type="button"
                  >
                    新增
                  </button>
                </div>
              </div>
              <div className="col-2"></div>
              <div className="container text-left">
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-8">
                    <DragDropContext onDragEnd={onDragEnd}>
                      <Droppable droppableId="todoList">
                        {(provided) => (
                          <ul
                            className="list-group list-group-flush"
                            style={{
                              maxHeight: "70vh",
                              overflowY: "auto",
                            }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {toDoListData.map((item, index) => (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="list-group-item border-bottom bg-light-subtle border-secondary-subtle list-group-item-action"
                                    style={{
                                      ...provided.draggableProps.style,
                                      // 拖拽时添加一点视觉反馈
                                      backgroundColor: snapshot.isDragging
                                        ? "#e9ecef"
                                        : "",
                                    }}
                                  >
                                    <input
                                      role="button"
                                      className="form-check-input cursor-pointer me-2"
                                      onClick={() => handleDeleteList(index)}
                                      type="radio"
                                      name="flexRadioDefault"
                                      id={`flexRadioDefault${index}`}
                                    />
                                    {item.text}

                                    <div
                                      style={{ fontSize: "0.7rem" }}
                                      className="mx-4"
                                    >
                                      {getFormattedDate(item.date)}
                                    </div>
                                  </li>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                  <div className="col-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Todoist_component;
